module.exports = __webpack_public_path__ + "60974c39a3598dc09996b0d51fe19da4.svg";